import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { Login, ResponseResult } from '@models/authentication/login';
import { HttpBaseService } from '@service/http-base.service';
import { AuthService } from '@service/auth.sevice';
import { AuthTokenHelper } from '@helpers/auth-token-helper';
import { UserMenuAuth } from '@helpers/usermenuauth';
import { NgxSpinnerService } from "ngx-spinner";
import { BeyondEMRConstants } from '@helpers/beyondemrconstants';
import { BeyondEMRHelper } from '@helpers/beyondemr-helper';
import { RoutingHelper } from '@helpers/routinghelper';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  login: Login;
  submitted = false;
  returnUrl: string;
  showValidation: boolean;
  public apiURL = null;
  hide = true;
  isRememberMe: boolean;
  IsDashboard: boolean = true;
  decryptedValue: string;
  loginResponse: ResponseResult

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private httpService: HttpBaseService,
    private authHelper?: AuthTokenHelper,
    private authService?: AuthService,
    private usermenu?: UserMenuAuth,
    private helper?: BeyondEMRHelper,
    private routingHelper?: RoutingHelper,
  ) {
    this.login = new Login();
  }
  ngOnInit() {
    this.httpService.getAPIURL().subscribe(url => {
      this.apiURL = `${url.API_URL}auth/Login`;
    });
    this.spinner.hide();

    this.getRememberMe();
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }
  onSubmit(formElement: NgForm) {
    this.spinner.show();
    // stop here if form is invalid
    if (formElement.invalid) {
      this.showValidation = true;
      this.spinner.hide();
    }
    else {
      this.showValidation = false;
      this.paramData();
      this.spinner.hide();
    }
  }

  rememberMe(usernames: string, password: string, domain: string) {
    var userRoleId = this.loginResponse.userRoleId;

    let username = '';

    if (userRoleId == BeyondEMRConstants.Role.Patient) {
      username = usernames + '@mlee';
    } else {
      username = usernames;
    }
    localStorage.setItem("Auth", JSON.stringify({ username, password, domain, remember: this.isRememberMe }))
  }

  removeRememberMe() {
    localStorage.removeItem("Auth");
  }

  getRememberMe() {
    let data = JSON.parse(localStorage.getItem("Auth")) as { username: string, password: string, domain: string, remember: boolean };
    if (data && data.username != null) {
      this.login.UserName = data.username;
      this.login.Password = data.password;
      this.login.Domain = data.domain;
      this.isRememberMe = data.remember;
    }
  }

  onToggleChange() {
    this.IsDashboard = !this.IsDashboard;
  }

  paramData() {
    if (this.IsDashboard == true) {
      let [UserName, domain]: string[] = this.login.UserName.split("@");
      let params = {
        domain: domain,
        UserName: UserName,
        Password: this.login.Password,
        IsPatient: this.IsDashboard
      }
      this.validateLogin(params);
    } else {
      const params = {
        domain: this.login.Domain,
        UserName: this.login.UserName,
        Password: this.login.Password,
        IsPatient: this.IsDashboard
      };
      this.validateLogin(params);
    }
  }


  public validateLogin(params) {
    if (this.submitted) return;
    this.submitted = true;
    this.httpService.postWithParameter(`${this.apiURL}`, params).subscribe(response => {
      var result = response as ResponseResult;
      this.loginResponse = result;
      if (result) {
        if (response.Status == "User Name or Password is wrong") {
          this.showValidation = true;
          this.submitted = false
        }
        else {
          this.showValidation = false;
          if (this.isRememberMe == true) {
            this.rememberMe(params.UserName, params.Password, params.domain);
          }
          else {
            this.removeRememberMe();
          }
          let encryptedData = btoa(encodeURIComponent(result.userSettingId));
          let username = result.userName;
          let userSettingId = result.userSettingId;
          let userroleid = result.userRoleId;
          let domainname = result.domainName;
          let tokenGeneratedTime = result.tokenGeneratedTime;
          let tokenExpiredTime = result.tokenExpiredTime;
          localStorage.setItem("loginObject", JSON.stringify({ username, userSettingId, userroleid, domainname, tokenGeneratedTime, tokenExpiredTime }));
          localStorage.removeItem("tokenTime");
          localStorage.removeItem("exp");
          localStorage.setItem("userSettingId", encryptedData);
          this.router.navigate(['/authentication/two-way-auth']);
        }
      }
      else {
        this.showValidation = false;
        if (this.isRememberMe == true) {
          this.rememberMe(params.UserName, params.Password, params.domain);
        }
        else {
          this.removeRememberMe();
        }
        let encryptedData = btoa(encodeURIComponent(result.userSettingId));
        let username = result.userName;
        let userSettingId = result.userSettingId;
        let userroleid = result.userRoleId;
        let domainname = result.domainName;
        let tokenGeneratedTime = result.tokenGeneratedTime;
        let tokenExpiredTime = result.tokenExpiredTime;
        localStorage.setItem("loginObject", JSON.stringify({ username, userSettingId, userroleid, domainname, tokenGeneratedTime, tokenExpiredTime }));

        localStorage.setItem("userSettingId", encryptedData);
        this.router.navigate(['/authentication/two-way-auth']);
      }
    }, error => {
      if ((error.status === 400 || error.status === 401) || (error.status === 401 && error.statusText == 'Unauthorized')) {
        this.showValidation = true;
        this.submitted = false;
        return false;
      }
      this.showValidation = true;
      this.submitted = false;
    });
  }
}
